// extracted by mini-css-extract-plugin
export default {"bg10":"styles_bg10__uREN-","body4":"styles_body4__UqFTE"};